import React from 'react';

import { ProjectsIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <ProjectsIcon size="xsmall" shouldUseNewLogoDesign label="" />;

export const useProjects = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
) => {
	return useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.PROJECTS,
		analyticsName: Products.PROJECTS,
		...options,
	});
};
